import React from 'react';
import { LanguageProvider } from './data/i18n';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Truth } from './components/Truth';
import { NextLevel } from './components/NextLevel';
import { Services } from './components/Services';
import { HouseCall } from './components/HouseCall';
import { Trust } from './components/Trust';
import { Hours } from './components/Hours';
import { Guarantee } from './components/Guarantee';
import { Booking } from './components/Booking';
import { Footer } from './components/Footer';
import { BackgroundAudio } from './components/BackgroundAudio';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="31ctflscv2296">
      <div className="w-full min-h-screen bg-black text-bone font-body" data-id="element-1" data-mp="2wka18t6cn33b">
        <Header data-id="element-2" data-mp="2whxbhtucnofp" />
        <main data-id="element-3" data-mp="28ufo0ai4bcij">
          <Hero data-id="element-4" data-mp="28tw62tsgwo4i" />
          <NextLevel data-id="element-5" data-mp="28te198rqp1kz" />
          <Trust data-id="element-6" data-mp="28suw6sn6u7od" />
          <Truth data-id="element-7" data-mp="28sb9yzqi8x4j" />
          <HouseCall data-id="element-8" data-mp="23vchelmhoy8g" />
          <Services data-id="element-9" data-mp="23vul23bheeqe" />
          <Hours data-id="element-10" data-mp="23ujkecdc1n3i" />
          <Guarantee data-id="element-11" data-mp="23v2r0wxj8p28" />
          <Booking data-id="element-12" data-mp="23ti7018ugoim" />
        </main>
        <Footer data-id="element-13" data-mp="3ikqzm1my986s" />
        <BackgroundAudio data-id="element-14" data-mp="3ij652c0mxp8x" />
      </div>
    </LanguageProvider>;
}